import React from 'react';

// import colors from 'themes/colors';

function CorrectedAddress(props) {
  const { originValue, correctedValue, originClassName, correctedClassName, originStyle, correctedStyle } = props;

  const differenceValue = !!correctedValue && originValue?.toLowerCase() !== correctedValue?.toLowerCase();
  return (
    <>
      <div className={originClassName} style={{ ...originStyle, textDecoration: differenceValue && 'line-through' }}>
        {originValue}
      </div>
      {differenceValue && (
        <div className={correctedClassName || originClassName} style={{ ...(correctedStyle || originStyle), color: '#3a6a4a' }}>
          {correctedValue}
        </div>
      )}
    </>
  );
}

export default CorrectedAddress;
